document.addEventListener("turbo:load", function() {
  if (!App.currentPageIs("connected_apps", "index")) { return; }

  App.oauthConnect("#salesforce-btn", "/auth/salesforce");
  App.oauthConnect("#hubspot-btn", "/auth/hubspot");
  App.oauthConnect("#zoho-btn", "/auth/zoho");
  App.oauthConnect("#outlook-btn", "/auth/outlook");
  return App.oauthConnect("#gmail-btn", "/auth/gmail");
});
